module.exports = __webpack_public_path__ + "static/media/ic_bookmark_empty.4cceaa76.svg";